import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "mg_cookie_consent";

export function getConsent() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!getConsent()) setShow(true);
  }, []);

  function choose(value) {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* ignore */
    }
    window.dispatchEvent(new CustomEvent("mg-consent-change", { detail: value }));
    setShow(false);
  }

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl border border-white/12 bg-black/85 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.6)] backdrop-blur-xl sm:inset-x-6 sm:bottom-6 sm:p-6"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
          <p className="text-sm leading-relaxed text-neutral-300">
            Deneyiminizi iyileştirmek için zorunlu çerezler kullanırız. Analitik çerezler yalnızca onayınızla çalışır. Detaylar için{" "}
            <Link to="/cerez-politikasi" className="text-gold underline-offset-2 hover:underline">
              Çerez Politikası
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 gap-2.5 sm:ml-auto">
          <button
            onClick={() => choose("rejected")}
            data-testid="cookie-reject"
            className="border border-white/15 px-5 py-2.5 font-oswald text-xs font-semibold uppercase tracking-[0.1em] text-neutral-300 transition-colors hover:border-white/40 hover:text-white"
          >
            Reddet
          </button>
          <button
            onClick={() => choose("accepted")}
            data-testid="cookie-accept"
            className="bg-gold px-5 py-2.5 font-oswald text-xs font-bold uppercase tracking-[0.1em] text-black transition-colors hover:bg-gold-300"
          >
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
}
